import React from 'react';

interface IShareSlotProps {
    children?: React.ReactNode;
}

const ShareSlot: React.FC<IShareSlotProps> = ({ children }) => (
    <div className="content-page__share">{children}</div>
);

export default ShareSlot;
